import React from 'react'
import { styled } from '@mui/material/styles'
import { Button } from '@mui/material'
import { IButtonPrimary } from './Types'

const ButtonStyle = styled((props) => <Button {...props} />)<IButtonPrimary>(
  ({ width }) => ({
    borderRadius: '10px',
    textTransform: 'capitalize',
    fontSize: '14px',
    width,
    minWidth: '32px',
  })
)

const PrimaryButton = {
  ButtonStyle,
}

export default PrimaryButton
